import { isError } from "lodash"

import { isPromise } from "@/lib/isPromise"
import type { ProcessLocking } from "@/lib/process_locking"
import { ReactPerformance } from "@/lib/react_performance"

export const asLockedProcess: ProcessLocking.Functions.AsLockedProcess =
  async ({ component, name, process }) => {
    const setState = ReactPerformance.hasManagedState(component)
      ? component.updateState
      : component.setState

    if (component.state.processing) {
      console.warn(
        `Process ${name} aborted because the component is already running a locked process: ${component.state.processing}.`
      )
      return {
        error: undefined,
        processed: false,
        result: undefined,
      }
    }

    setState({ processing: name })

    try {
      const calledProcess = process()

      const result = isPromise(calledProcess)
        ? await calledProcess
        : calledProcess

      return {
        error: undefined,
        processed: true,
        result,
      }
    } catch (throwable) {
      const error = isError(throwable)
        ? throwable
        : new Error(JSON.stringify(throwable))

      return {
        error,
        processed: true,
        result: undefined,
      }
    } finally {
      setState({ processing: undefined })
    }
  }
